import type { CandidateResource } from '@studio/shared';
import type { ReactNode } from 'react';
import { Link } from '../shell/router.js';

/**
 * R060. Which idea a descendant grew out of.
 *
 * `parent_id` has been stored and served since task 07 and no screen read it, so on the
 * shelf a branch and a fresh direction looked exactly alike - and the whole reason to
 * branch is that the descendant is a variation on something the operator already chose.
 * The parent is always inside the same Experiment, which is why nothing here fetches:
 * the Experiment detail the surface already holds is the whole lineage.
 *
 * One component, mounted where a Candidate is read. There is no second wording of this.
 */

export function parentOf(
  candidates: readonly CandidateResource[],
  candidate: CandidateResource | null,
): CandidateResource | null {
  if (candidate === null || candidate.parentId === null) return null;
  return candidates.find((one) => one.id === candidate.parentId) ?? null;
}

export function Lineage({
  candidate,
  parent,
  experimentId,
}: {
  candidate: CandidateResource | null;
  parent: CandidateResource | null;
  experimentId: string;
}): ReactNode {
  if (candidate === null || candidate.parentId === null) return null;
  const refinement = candidate.refinement === null ? '' : ` · ${candidate.refinement}`;
  if (parent === null) {
    return <p className="note">{`Вырос из Candidate, которого уже нет на этой полке${refinement}`}</p>;
  }
  return (
    <p className="note">
      <Link to={`/experiments/${experimentId}/refine/${parent.id}`} className="secondary-link">
        {`Вырос из ${parent.headline}`}
      </Link>
      {refinement}
    </p>
  );
}
